import { useNarrativeTrackingFieldAction } from './useNarrativeTrackingFieldAction';

type Props = {
  trackEvent: (data: Record<string, string | number | boolean>) => void;
  fieldName: string;
  isModified: boolean;
  hasError: boolean;
};

export const useNarrativeTrackingField = ({
  trackEvent,
  fieldName,
  isModified,
  hasError,
}: Props) => {
  useNarrativeTrackingFieldAction({
    trackEvent,
    fieldName,
    shouldTrack: isModified,
    action: 'field_modified',
  });

  useNarrativeTrackingFieldAction({
    trackEvent,
    fieldName,
    shouldTrack: hasError,
    action: 'field_error',
  });
};
